import { onRequest as ___middleware_ts_onRequest } from "/home/runner/work/vampa/vampa/packages/cloudflare-pages-plugin-cal-com/functions/_middleware.ts"

export const routes = [
    {
      routePath: "/",
      mountPath: "/",
      method: "",
      middlewares: [___middleware_ts_onRequest],
      modules: [],
    },
  ]